export default __webpack_public_path__ + "images/JU.7b36766.png";